var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxLine = function SvgBoxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 3.125 5.938 3.438v6.875L10 16.875l-5.937-3.437V6.562zM5.934 6.924 10 9.278l4.066-2.354L10 4.569zm-.622 1.084v4.709l4.063 2.352V10.36zm5.313 7.06 4.063-2.351V8.008l-4.063 2.352z"
  })));
};
export default SvgBoxLine;